// @mui
import { styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton } from '@mui/material';

// ----------------------------------------------------------------------

export const StyledNavItem = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 50,
  position: 'relative',
  textTransform: 'capitalize',
  color: theme.palette.text.secondary.contrastText,
  borderRadius: theme.shape.borderRadius,
  fontWeight: '500',
  margin: '15px 0',
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  width: 20,
  height: 20,
  color: 'inherit',
  // display: 'flex',
  // alignItems: 'center',
  // justifyContent: 'center',
});
